/**
 * DevExtreme (esm/__internal/ui/scroll_view/utils/get_scroll_left_max.js)
 * Version: 25.1.6
 * Build date: Mon Oct 13 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export function getScrollLeftMax(element) {
  return element.scrollWidth - element.clientWidth;
}